export const it = {
  "app.title": "survivrr.io",
  "menu.online": "Online",
  "menu.offline": "Offline",
  "menu.play": "Gioca",
  "menu.name": "Nome",
  "menu.ballColor": "Colore della palla",
  "menu.nameColor": "Colore del nome",
  "menu.moreInfo": "Altre info",
  "menu.moreInfoTitle": "Altre info",
  "menu.moreInfoSubtitle": "Pagine legali, dettagli sui cookie e informazioni di contatto.",
  "menu.back": "Indietro",
  "menu.privacySettings": "Impostazioni privacy",
  "menu.cookiePolicy": "Informativa sui cookie",
  "menu.privacyPolicy": "Informativa sulla privacy",
  "menu.termsOfService": "Termini di servizio",
  "menu.emailButton": "Inviami un'e-mail",
  "menu.websiteButton": "Visita il mio sito",
  "menu.contactEmailLabel": "E-mail di contatto:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Visita il mio sito:",
  "menu.nameRequired": "Inserisci prima un nome.",
  "moreInfo.privacySettings.intro1": "Puoi gestire le tue scelte sulla privacy su questo sito tramite il messaggio di consenso mostrato dal nostro fornitore di pubblicità quando è disponibile.",
  "moreInfo.privacySettings.intro2": "Puoi anche controllare cookie e archiviazione locale dalle impostazioni del browser in qualsiasi momento.",
  "moreInfo.privacySettings.adsHeading": "Controlli pubblicitari",
  "moreInfo.privacySettings.adsParagraph": "Alcuni annunci possono essere forniti da Google o da altri partner. Le scelte per la pubblicità personalizzata possono essere gestite anche direttamente nelle impostazioni degli annunci di Google.",
  "moreInfo.privacySettings.adsBullet1": "Apri i controlli degli annunci di Google su myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Cancella cookie o dati del sito se vuoi reimpostare le tue scelte di consenso.",
  "moreInfo.privacySettings.adsBullet3": "Usa le impostazioni privacy del browser per bloccare o limitare i cookie.",
  "moreInfo.privacySettings.localHeading": "Impostazioni locali",
  "moreInfo.privacySettings.localParagraph": "Questo gioco salva preferenze locali di base come nome giocatore, colori, preferenza audio e lingua, così il sito può ricordarle sul tuo dispositivo.",
  "moreInfo.cookiePolicy.intro1": "Questo sito usa cookie e tecnologie di archiviazione simili per eseguire il gioco, ricordare le impostazioni e supportare la pubblicità.",
  "moreInfo.cookiePolicy.intro2": "I cookie possono essere usati anche per misurazioni, prevenzione delle frodi e personalizzazione degli annunci in base alle tue scelte di consenso e ai servizi attivati sul sito.",
  "moreInfo.cookiePolicy.typesHeading": "Tipi di cookie e archiviazione che possiamo usare",
  "moreInfo.cookiePolicy.typeBullet1": "Archiviazione essenziale usata per far funzionare il sito.",
  "moreInfo.cookiePolicy.typeBullet2": "Archiviazione delle preferenze usata per ricordare nome, colori, lingua e impostazione audio.",
  "moreInfo.cookiePolicy.typeBullet3": "Cookie pubblicitari o di misurazione usati da partner pubblicitari come Google quando gli annunci sono attivati.",
  "moreInfo.cookiePolicy.manageHeading": "Come gestire i cookie",
  "moreInfo.cookiePolicy.manageParagraph": "Puoi gestire i cookie tramite il messaggio di consenso del sito quando disponibile, oppure dalle impostazioni del browser. Disattivare alcuni cookie può influire su funzioni del sito o sulla pubblicazione degli annunci.",
  "moreInfo.privacyPolicy.intro1": "Questo sito è un gioco per browser gestito da Michał Kierzkowski. Cerchiamo di raccogliere meno informazioni personali possibile.",
  "moreInfo.privacyPolicy.intro2": "Non è richiesto un account per giocare. Il gioco può salvare preferenze locali di base sul tuo dispositivo ed elaborare dati di gioco necessari per le partite online.",
  "moreInfo.privacyPolicy.infoHeading": "Informazioni che possiamo elaborare",
  "moreInfo.privacyPolicy.infoBullet1": "Il nome giocatore scelto e le impostazioni estetiche.",
  "moreInfo.privacyPolicy.infoBullet2": "Dati di sessione di base necessari per le funzioni multigiocatore.",
  "moreInfo.privacyPolicy.infoBullet3": "Dati di dispositivo, browser o pubblicità raccolti da partner di analisi o pubblicitari se tali servizi sono attivati.",
  "moreInfo.privacyPolicy.useHeading": "Come usiamo le informazioni",
  "moreInfo.privacyPolicy.useBullet1": "Per eseguire il gioco e le stanze online.",
  "moreInfo.privacyPolicy.useBullet2": "Per ricordare le impostazioni sul tuo dispositivo.",
  "moreInfo.privacyPolicy.useBullet3": "Per migliorare prestazioni, sicurezza e stabilità.",
  "moreInfo.privacyPolicy.useBullet4": "Per mostrare annunci quando la pubblicità è attiva.",
  "moreInfo.privacyPolicy.contactHeading": "Contatto",
  "moreInfo.privacyPolicy.contactParagraph1": "Per domande relative alla privacy, contatta: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Sito web: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Usando questo sito, accetti di usare il gioco in modo legale e corretto.",
  "moreInfo.terms.intro2": "Il gioco è fornito così com'è e può essere modificato, interrotto o rimosso in qualsiasi momento.",
  "moreInfo.terms.rulesHeading": "Regole",
  "moreInfo.terms.ruleBullet1": "Non abusare di bug, cheat, automazione o exploit.",
  "moreInfo.terms.ruleBullet2": "Non tentare di danneggiare il servizio o altri giocatori.",
  "moreInfo.terms.ruleBullet3": "Non usare nomi o contenuti offensivi, illegali o ingannevoli.",
  "moreInfo.terms.limitationHeading": "Limitazione",
  "moreInfo.terms.limitationParagraph": "Non siamo responsabili di perdite, interruzioni o danni derivanti dall'uso del sito nella misura massima consentita dalla legge.",
  "moreInfo.terms.changesHeading": "Modifiche",
  "moreInfo.terms.changesParagraph": "Questi termini possono essere aggiornati in futuro. Continuare a usare il sito dopo gli aggiornamenti significa accettare i termini aggiornati.",
  "status.offline": "Avvio partita offline...",
  "status.connecting": "Connessione al server...",
  "queue.title": "In attesa di una stanza",
  "queue.menu": "Torna al menu principale",
  "game.pressToMove": "Premi ovunque per muoverti",
  "game.touchToMove": "Tocca ovunque per muoverti",
  "game.leaderboard": "Classifica",
  "game.hp": "PV",
  "game.level": "Livello",
  "game.xp": "XP",
  "game.respawning": "Respawn...",
  "gameEnd.title": "Fine partita",
  "gameEnd.winTitle": "Hai vinto",
  "gameEnd.subtitle": "La partita è terminata. Rinasci per iniziare il prossimo round o torna al menu.",
  "pause.title": "Menu di gioco",
  "pause.resume": "Continua",
  "pause.menu": "Torna al menu principale",
  "upgrade.title": "Scegli un potenziamento",
  "upgrade.generic.title": "Potenziamento",
  "upgrade.generic.description": "Migliora la tua build.",
  "upgrade.newWeaponPrefix": "Nuova arma:",
  "upgrade.stat.maxHp.title": "PV massimi",
  "upgrade.stat.maxHp.description": "Aumenta i PV massimi.",
  "upgrade.stat.speed.title": "Velocità di movimento",
  "upgrade.stat.speed.description": "Aumenta la velocità di movimento.",
  "upgrade.stat.generic.title": "Potenziamento statistica",
  "upgrade.stat.generic.description": "Migliora le tue statistiche.",
  "upgrade.weapon.projectileShot.title": "Colpo proiettile",
  "upgrade.weapon.projectileShot.description": "Aggiunge colpi proiettile alla tua build.",
  "upgrade.weapon.orbitingBalls.title": "Sfere orbitanti",
  "upgrade.weapon.orbitingBalls.description": "Aggiunge sfere orbitanti alla tua build.",
  "upgrade.weapon.damageZone.title": "Zona di danno",
  "upgrade.weapon.damageZone.description": "Aggiunge una zona di danno intorno al personaggio.",
  "upgrade.weapon.generic.title": "Arma",
  "upgrade.weapon.generic.description": "Aggiungi quest'arma alla tua build.",
  "upgrade.weaponUpgrade.frequency.title": "Frequenza",
  "upgrade.weaponUpgrade.frequency.description": "Attacca più spesso.",
  "upgrade.weaponUpgrade.range.title": "Portata",
  "upgrade.weaponUpgrade.range.description": "Aumenta la portata dell'arma.",
  "upgrade.weaponUpgrade.projectileCount.title": "Numero di proiettili",
  "upgrade.weaponUpgrade.projectileCount.description": "Crea più proiettili.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Velocità proiettili",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Rende i proiettili più veloci.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Velocità orbitale",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Fa ruotare più velocemente le sfere orbitanti.",
  "upgrade.weaponUpgrade.damage.title": "Danno",
  "upgrade.weaponUpgrade.damage.description": "Infligge più danni.",
  "upgrade.weaponUpgrade.generic.title": "Potenziamento arma",
  "upgrade.weaponUpgrade.generic.description": "Migliora quest'arma.",
  "defeat.title": "Sconfitta",
  "defeat.subtitle": "Rinasci o torna al menu",
  "defeat.respawn": "Rinasci",
  "defeat.menu": "Menu principale",
  "error.generic": "Qualcosa è andato storto.",
} as const;
